var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-creator-audition-complete"},[_c('CompleteTemplate',{attrs:{"title":"申請が完了しました","description1":"募集要項をご記入いただき、ありがとうございました！","description2":"現在、事務局が内容を確認しております。少々お待ちください。","buttonText":"自社依頼へ","linkPath":"/basecamp/job_offers/histories"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }